import React from 'react'
import PropTypes from 'prop-types'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 6,
    slidesToSlide: 1, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 4,
    slidesToSlide: 1, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 3,
    slidesToSlide: 1, // optional, default to 1.
  },
}
const CarouselComponent = ({ children }) => (
  <>
    <Carousel
      swipeable
      isAnimationAllowed
      draggable
        //   showDots
      responsive={ responsive }
      ssr // means to render carousel on server-side.
      infinite
            // autoPlay={this.props.deviceType !== "mobile" ? true : false}
      autoPlay
      autoPlaySpeed={ 3000 }
      keyBoardControl
      customTransition='all 2'
      transitionDuration={ 500 }
      containerClass='carousel-container'
        //   removeArrowOnDeviceType={ [ 'tablet', 'mobile' ] }
            // deviceType={this.props.deviceType}
      dotListClass='custom-dot-list-style'
      itemClass='carousel-item-padding-40-px'
    >
      { children }
    </Carousel>
  </>
)

CarouselComponent.propTypes = {
  children: PropTypes.element.isRequired,
}

export default CarouselComponent
